import React, { FC } from "react";

import { ClubLogoIcon } from "../../../icons";
import SvgIcon from "../../Icons/SvgIcon";
import { ILink } from "../../ActionsSelectors";
import { TPrice, ProductPrice } from "../Price";
import { LinkButton } from "../../ActionsSelectors/Button";
import { onlyMainPrices } from "../Price/ProductPrice";

export interface ILoyaltyProgramProps {
  /**
   * Product price data
   */
  prices?: TPrice[];
  /**
   * Link data with amount of `Club points`
   */
  clubPoints?: ILink;
}

/**
 * Template component for display product cost information.
 * Such as price, discount and club points
 */
const LoyaltyProgram: FC<ILoyaltyProgramProps> = ({ prices, clubPoints }) => {
  const mainPrices = onlyMainPrices(prices);
  return (
    <div className="product-values">
      <ProductPrice prices={mainPrices} />
      {clubPoints && (
        <div className="product-loyalty">
          <SvgIcon
            icon={ClubLogoIcon}
            width={42}
            height={16}
            classes={{ root: "club-logo" }}
          />
          <LinkButton variant="bold" classes={{ root: "ms-4" }}>
            85 points
          </LinkButton>
        </div>
      )}
    </div>
  );
};

export default LoyaltyProgram;
